module.exports = __webpack_public_path__ + "img/Artboard 50.7d90c402.png";